<template>
  <footer class="footer">
    <div class="footer-glow"></div>
    <div class="bd-grid footer-container">
      <div class="footer-brand">
        <img src="@/assets/logo2.png" alt="Invextia" class="footer-logo">
        <p class="footer-text">
          Invextia es tu <strong>copiloto financiero</strong>: analiza, aconseja y distribuye tu dinero automáticamente.
        </p>
        <div class="brand-badge">
          <span class="badge-pulse"></span>
          <span class="badge-text">Fintech Innovador</span>
        </div>
      </div>

      <nav class="footer-links" aria-label="Enlaces de navegación">
        <h4 class="footer-title">{{ $t('footer.explore') }}</h4>
        <div class="links-list">
          <a href="#home" class="footer-link">
            <span class="link-indicator"></span>
            {{ $t('nav.home') }}
          </a>
          <a href="#about" class="footer-link">
            <span class="link-indicator"></span>
            {{ $t('nav.about') }}
          </a>
          <a href="#skills" class="footer-link">
            <span class="link-indicator"></span>
            {{ $t('nav.skills') }}
          </a>
          <a href="#pricing" class="footer-link">
            <span class="link-indicator"></span>
            {{ $t('nav.pricing') }}
          </a>
          <a href="#faq" class="footer-link">
            <span class="link-indicator"></span>
            {{ $t('nav.faq') }}
          </a>
          <a href="#contact" class="footer-link">
            <span class="link-indicator"></span>
            {{ $t('nav.contact') }}
          </a>
        </div>
      </nav>

      <div class="footer-contact">
        <h4 class="footer-title">{{ $t('nav.contact') }}</h4>
        <div class="contact-info">
          <a href="mailto:invextia.col@gmail.com" class="contact-item">
            <i class="fa fa-envelope-o" aria-hidden="true"></i>
            <span>invextia.col@gmail.com</span>
          </a>
          <a href="tel:+573242845231" class="contact-item">
            <i class="fa fa-phone" aria-hidden="true"></i>
            <span>+57 324 284 5231</span>
          </a>
        </div>

        <div class="social-wrapper" aria-label="Redes sociales">
          <div class="social-title">Síguenos</div>
          <ul class="social-list">
            <li class="social-item x-twitter">
              <a href="https://x.com/Invextia" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <span class="tooltip">X (Twitter)</span>
            </li>
            <li class="social-item linkedin">
              <a href="https://linkedin.com/company/invextia" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i class="fa fa-linkedin" aria-hidden="true"></i>
              </a>
              <span class="tooltip">LinkedIn</span>
            </li>
            <li class="social-item instagram">
              <a href="https://www.instagram.com/invextia_col/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i class="fa fa-instagram" aria-hidden="true"></i>
              </a>
              <span class="tooltip">Instagram</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="bottom-content">
        <small class="copyright">© {{ year }} Invextia. {{ $t('footer.rights') }}</small>
        <div class="footer-decoration">
          <span class="decoration-line"></span>
          <span class="decoration-dot"></span>
          <span class="decoration-line"></span>
        </div>
      </div>
    </div>
  </footer>
</template>


<script>
import "font-awesome/css/font-awesome.min.css";

export default {
  name: 'FooterSection',
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>

<style src="@/styles/Footer-Section.css"></style>